import t from"../palette/palette.js";const e={styleOverrides:{root:{color:t.black80.main}}};export{e as MuiTypography};
//# sourceMappingURL=MuiTypography.js.map
